import { FC } from 'react';

import { AppRouter } from 'routers/AppRouter';

import ja from 'date-fns/locale/ja';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

registerLocale('ja', ja);
setDefaultLocale('ja');

export const App: FC = () => <AppRouter />;
